module.exports = __webpack_public_path__ + "img/coldwell.3a337049.png";